/**
 * Unauthorized page - Shown when user lacks required permissions.
 */

import { Link } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-8">
      <ShieldAlert className="text-destructive h-16 w-16" />
      <h1 className="mt-6 text-2xl font-semibold">Accès non autorisé</h1>
      <p className="text-muted-foreground mt-2 max-w-md text-center">
        Vous n'avez pas les permissions nécessaires pour accéder à cette page. Contactez votre
        administrateur si vous pensez qu'il s'agit d'une erreur.
      </p>
      <Button asChild className="mt-8">
        <Link to="/">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Retour à l'accueil
        </Link>
      </Button>
    </div>
  );
}
